export const HAS_SENSITIVE_DATA_BANNER_STORAGE_KEY = 'HAS_SENSITIVE_DATA_BANNER_IN_INBOX';